var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28863 0.869069C7.70576 0.38741 7.91432 0.146581 8.16196 0.0581925C8.37935 -0.0193975 8.61688 -0.0193975 8.83427 0.0581925C9.08191 0.146581 9.29047 0.387411 9.7076 0.869069L15.2986 7.32503C16.0275 8.16668 16.392 8.5875 16.4021 8.94411C16.4109 9.254 16.2754 9.55044 16.0354 9.74667C15.7592 9.97247 15.2025 9.97248 14.0891 9.97248H2.90709C1.7937 9.97248 1.237 9.97247 0.960802 9.74667C0.720791 9.55044 0.58536 9.254 0.594153 8.94411C0.604272 8.5875 0.968716 8.16668 1.6976 7.32503L7.28863 0.869069Z",
    fill: "#4285F4",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonIcon);
export default __webpack_public_path__ + "static/media/polygonIcon.74c272844941d4972f906a3aa0f1bd6c.svg";
export { ForwardRef as ReactComponent };